import React, { useEffect, useState } from "react"

import { Swiper, SwiperSlide } from "swiper/react"

import SwiperCore, { Navigation, Keyboard, A11y, FreeMode } from "swiper"

import dynamic from "next/dynamic"

import rightArrow from "@/public/icons/right-arrow.svg"
import leftArrow from "@/public/icons/left-arrow.svg"

import "swiper/swiper.css"
import Styles from "@/components/MultiFinshProductBundle/styles/ProductOptionSelectorUI.module.scss"
import { useStore } from "../context/store"
import { setSelectedProductsAction } from "@/components/MultiFinshProductBundle/context/actions"

const QuickView = dynamic(() => import("@/components/Shared/QuickView"))

import Modal from "@/components/core/Modal/Modal"
import { preventPopupScroll } from "@/components/Shared/QuickView/utlis"

import ProductOptionSelectorSwiperSlideUI from "@/components/MultiFinshProductBundle/ui/ProductOptionSelectorSwiperSlideUI"
import { navigationAnalytics } from "@/components/MultiFinshProductBundle/analytics"
import {
  quickViewOpenAnalytics,
  quickViewCloseAnalytics,
} from "@/components/Shared/QuickView/analytics.js"
import { getUserPersona } from "@/utils/helper"
import { getProductInfoForAnalytics } from "@/components/MultiFinshProductBundle/analytics/getProductInfo"

const ProductOptionSelectorUI = props => {
  const {
    data: { products: productsList = [], name = "" } = {},
    prevButtonRef = null,
    nextButtonRef = null,
    isPrevVisible = false,
    isNextVisible = false,
    setIsNextVisible = () => {},
    setIsPrevVisible = () => {},
    isAllSlidesVisible = false,
    updateButtonVisibility = () => {},
    staticTexts = {},
    index = 0,
    quickViewAuthData = {},
    swatchName,
    selectedProducts = [],
    productInfoBundle = [],
    config = {},
    setTriggerAnalyticsOnProductClick = () => {},
  } = props || {}

  const { state, dispatch } = useStore()
  const {
    projectionData = [],
    inventory = [],
    imageGallery: { bundleListImages = [] } = {},
  } = state
  const {
    general: { siteName = "kohler" } = {},
    internationalization: { currencyCode = "USD" } = {},
  } = config

  const [showQuickViewModal, setShowQuickViewModal] = useState(false)
  const [quickViewProductData, setQuickViewProductData] = useState([])
  const [quickViewSelectedSku, setQuickViewSelectedSku] = useState("")
  const [productInfo, setProductInfo] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  const commonProductInfo = {
    bundleIds: productInfoBundle[0]?.bundleIds,
    bundlePrice: productInfoBundle[0]?.bundlePrice,
    bundleProductColors: productInfoBundle[0]?.bundleProductColors,
    pdpType: productInfoBundle[0]?.pdpType,
  }

  const handleProductInfo = data => {
    setProductInfo({
      ...data,
      ...commonProductInfo,
    })
  }

  const optionCategory = name?.replace(/^\d+\.\s*/, "").toLowerCase() || ""

  const openPdpQuickViewModal = (
    QuickViewProductData,
    quickViewSelectedSku
  ) => {
    const { slug, title } = QuickViewProductData || {}

    const quickViewData = {
      slug_s: slug,
      RegionBrandName_s: title,
      title_s: title,
      sku_s: quickViewSelectedSku,
    }
    setQuickViewSelectedSku(quickViewSelectedSku)
    setQuickViewProductData(quickViewData)
    setShowQuickViewModal(true)

    const persona = getUserPersona()
    const productDataForAnalytics = getProductInfoForAnalytics({
      ...QuickViewProductData,
      siteName,
      swatchName,
      inventory,
      projectionData,
      currencyCode,
      bundleListImages,
      persona,
      sku: quickViewSelectedSku,
    })
    quickViewOpenAnalytics({
      isMultifinishBundle: true,
      productData: productDataForAnalytics,
      optionCategory,
      commonProductInfo,
    })
  }

  const closeQuickViewModal = () => {
    setShowQuickViewModal(false)
    preventPopupScroll(true)
  }

  const handleButtonClosed = () => {
    quickViewCloseAnalytics({
      isMultifinishBundle: true,
      productInfo: [productInfo],
      optionCategory,
    })
  }

  SwiperCore.use([Keyboard, A11y, FreeMode])

  const handleSelectItem = data => {
    dispatch(
      setSelectedProductsAction({ id: index, name, swatchName, ...data })
    )
  }

  const products = productsList.filter(item => {
    const findItem = item.colorDetails.some(e => e.name === swatchName)
    return findItem && item
  })

  const { masterSku, sku: variantSku } = selectedProducts[index] || {}

  const { title, colorDetails = [] } =
    products.find(product => product.masterSku === masterSku) || {}
  const { customerFacingSku = "" } =
    colorDetails.find(item => item.sku === variantSku) || {}

  useEffect(() => {
    if (showQuickViewModal) {
      preventPopupScroll()
    }
  }, [showQuickViewModal])

  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      setIsLoading(false)
    }, 100)

    return () => clearTimeout(loadingTimer)
  }, [])

  return (
    <>
      <div className={Styles.ProductOptionSelectorUIWrapper}>
        <p className="user-action">{name}</p>
        <p className="product-description">
          {customerFacingSku}, {title}
        </p>
        <div
          className={`swiper-container-wrapper ${
            isLoading ? "is-loading" : ""
          }`}
        >
          <Swiper
            className="swiper-container"
            modules={[Navigation, Keyboard, A11y, FreeMode]}
            spaceBetween={"20px"}
            slidesPerView={"auto"}
            navigation={{
              nextEl: nextButtonRef.current,
              prevEl: prevButtonRef.current,
            }}
            onBeforeInit={swiper => {
              swiper.params.navigation.prevEl = prevButtonRef.current
              swiper.params.navigation.nextEl = nextButtonRef.current
            }}
            onSlideChange={updateButtonVisibility}
            onSetTranslate={swiper => updateButtonVisibility(swiper)}
            onInit={swiper => {
              updateButtonVisibility(swiper)
              setIsLoading(false)
            }}
            onReachEnd={() => setIsNextVisible(false)}
            onReachBeginning={() => setIsPrevVisible(false)}
            allowTouchMove={true}
            touchStartPreventDefault={false}
            simulateTouch={true}
            freeMode={true}
            draggable={true}
          >
            {products.map((product, i) => {
              return (
                <SwiperSlide key={product.sku}>
                  <ProductOptionSelectorSwiperSlideUI
                    swatchName={swatchName}
                    product={product}
                    staticTexts={staticTexts}
                    openPdpQuickViewModal={openPdpQuickViewModal}
                    handleSelectItem={handleSelectItem}
                    variantSku={variantSku}
                    setTriggerAnalyticsOnProductClick={
                      setTriggerAnalyticsOnProductClick
                    }
                    optionCategory={optionCategory}
                  />
                </SwiperSlide>
              )
            })}

            <div
              className={`caraousal-button-container ${
                isAllSlidesVisible ? "all-slides-visible" : ""
              }`}
            >
              <img
                src={leftArrow.src}
                className={`custom-prev-button ${
                  !isPrevVisible ? "hidden" : ""
                }`}
                alt="custom-prev-button"
                ref={prevButtonRef}
                onClick={() => navigationAnalytics(productInfoBundle, "left")}
              />

              <img
                src={rightArrow.src}
                className={`custom-next-button ${
                  !isNextVisible ? "hidden" : ""
                }`}
                alt="custom-next-button"
                ref={nextButtonRef}
                onClick={() => navigationAnalytics(productInfoBundle, "right")}
              />
            </div>
          </Swiper>
        </div>
      </div>
      <Modal
        showModal={showQuickViewModal}
        onModalClose={closeQuickViewModal}
        isCloseButtonClicked={handleButtonClosed}
        className="quickview-modal"
      >
        <QuickView
          productData={quickViewProductData}
          authorData={quickViewAuthData}
          closeModal={closeQuickViewModal}
          isMultifinishBundle={true}
          quickViewSelectedSku={quickViewSelectedSku}
          productOptionCategory={optionCategory}
          productInfoBundle={productInfoBundle}
          handleProductInfo={handleProductInfo}
        />
      </Modal>
    </>
  )
}

export default ProductOptionSelectorUI
